var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"main-content mt20"},[_c(_setup.MFolderTagsSection,_vm._b({ref:"folderTagsSectionRef"},'m-folder-tags-section',_vm.$attrs,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }